var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignLines90Deg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 165,
    viewBox: "0 0 221 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_214)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5285 19.158H64.6817V18.1378H47.9369L33.8468 3.65134H2.29729L-3.72673 -2.36768H-31.0901L-47.1201 13.7511L-46.4054 14.4652L-30.5796 -1.24549H-4.13513L1.88889 4.77353L33.3363 4.67152L47.5285 19.158Z",
    fill: "url(#paint0_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.0991 40.9896H-17.2042L3.01199 20.7902H23.6366L42.9339 40.0715H109.607L125.126 24.4628H147.18V23.4426H124.718L109.096 39.0513H43.3423L24.045 19.77H2.60358L-17.7147 39.9694H-46.0991V40.9896Z",
    fill: "url(#paint1_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.952 55.0681H152.183L160.147 47.1107H192.82V46.0905H159.739L151.775 54.0479H107.462L80.3033 26.9113H38.7477L19.8589 8.03809H-30.3754L-38.7477 16.4035H-47.1201V17.5257H-38.3393L-29.8649 9.05826H19.4504L38.3393 27.9315H79.7928L106.952 55.0681Z",
    fill: "url(#paint2_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4053 118.727H30.7837L49.7746 99.8536H73.7686L127.27 46.3965H146.874V45.3763H126.76L73.3602 98.7314H49.2641L30.3752 117.707H12.4053V118.727Z",
    fill: "url(#paint3_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.3634 59.5568H16.4895L27.3123 48.743H86.3273V46.6006H26.3934L15.6727 57.4145H-9.54654L-23.2282 43.7441H-47.1201V45.7845H-24.1471L-10.3634 59.5568Z",
    fill: "url(#paint4_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6035 79.3482H79.2822V78.226H37.0119L23.7386 64.9637H-22.5136L-31.0902 56.3943H-48.856V57.5165H-31.4986L-22.922 66.0859H23.3302L36.6035 79.3482Z",
    fill: "url(#paint5_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27952 98.9355H25.1684L65.4987 58.5367H91.6369L111.036 77.9199H174.544L185.367 88.7338H200.682V86.5914H186.183L175.361 75.7776H111.853L92.5558 56.3943H64.6819L24.2495 96.7931H7.09634L-1.48024 88.1217H-48.5493V90.264H-2.39916L6.27952 98.9355Z",
    fill: "url(#paint6_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6817 93.8346H100.417L132.375 61.8012H169.541L169.438 59.6588H131.559L99.4985 91.6922H31.6006L16.5916 76.7977H-47.1201V78.8381H15.6727L30.6817 93.8346Z",
    fill: "url(#paint7_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.096 101.282H200.682V100.16H177.504L161.781 84.449H116.447V85.4692H161.27L177.096 101.282Z",
    fill: "url(#paint8_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.8048 144.741H49.3664L72.3393 121.787H113.793L130.027 105.465H146.465V104.444H129.619L113.384 120.665H71.9309L48.958 143.619H-31.2943L-45.7928 129.133H-51V130.255H-46.3033L-31.8048 144.741Z",
    fill: "url(#paint9_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.3274 173H50.081L57.1261 165.961H94.2913L142.79 117.503H208.237L217.937 127.296L218.754 126.48L208.646 116.482H142.381L93.8828 164.941H56.7177L49.6726 171.98H-17.8168L-23.2283 166.675H-49.979V167.695H-23.6367L-18.3274 173Z",
    fill: "url(#paint10_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.195 128.112H160.249V127.092H104.604L84.081 106.587H10.4654L-12.916 83.2247H-48.856V84.2449H-13.3244L9.95485 107.607H83.6726L104.195 128.112Z",
    fill: "url(#paint11_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6396 18.6479C62.6396 19.8721 63.5586 20.7902 64.7838 20.7902C66.009 20.7902 66.9279 19.8721 66.9279 18.6479C66.9279 17.4236 66.009 16.5055 64.7838 16.5055C63.5586 16.5055 62.6396 17.4236 62.6396 18.6479Z",
    fill: "url(#paint12_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.036 24.1568C145.036 25.381 145.955 26.2991 147.18 26.2991C148.303 26.2991 149.324 25.381 149.324 24.1568C149.324 22.9326 148.405 22.0144 147.18 22.0144C145.955 22.0144 145.036 22.9326 145.036 24.1568Z",
    fill: "url(#paint13_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.321 46.4986C144.321 47.6208 145.24 48.6409 146.465 48.6409C147.691 48.6409 148.61 47.7228 148.61 46.4986C148.61 45.2744 147.691 44.3562 146.465 44.3562C145.24 44.3562 144.321 45.2744 144.321 46.4986Z",
    fill: "url(#paint14_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.129 100.772C198.129 101.894 199.048 102.914 200.273 102.914C201.498 102.914 202.417 101.996 202.417 100.772C202.417 99.5476 201.396 98.6294 200.273 98.6294C199.048 98.6294 198.129 99.5476 198.129 100.772Z",
    fill: "url(#paint15_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.303 84.9591C114.303 86.1833 115.222 87.1015 116.447 87.1015C117.673 87.1015 118.592 86.1833 118.592 84.9591C118.592 83.7349 117.673 82.8168 116.447 82.8168C115.222 82.8168 114.303 83.7349 114.303 84.9591Z",
    fill: "url(#paint16_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.015 104.75C144.015 105.975 144.934 106.893 146.159 106.893C147.384 106.893 148.303 105.975 148.303 104.75C148.303 103.526 147.384 102.608 146.159 102.608C144.934 102.608 144.015 103.526 144.015 104.75Z",
    fill: "url(#paint17_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.135 117.503C140.135 118.625 141.054 119.645 142.279 119.645C143.505 119.645 144.424 118.727 144.424 117.503C144.424 116.278 143.505 115.36 142.279 115.36C141.054 115.36 140.135 116.278 140.135 117.503Z",
    fill: "url(#paint18_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0391 98.9355C48.0391 100.16 48.958 101.078 50.1832 101.078C51.4084 101.078 52.3274 100.16 52.3274 98.9355C52.3274 97.7112 51.4084 96.7931 50.1832 96.7931C48.958 96.7931 48.0391 97.7112 48.0391 98.9355Z",
    fill: "url(#paint19_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4927 64.9637C21.4927 66.0858 22.4116 67.106 23.6368 67.106C24.862 67.106 25.781 66.1879 25.781 64.9637C25.781 63.7394 24.862 62.8213 23.6368 62.8213C22.4116 62.8213 21.4927 63.7394 21.4927 64.9637Z",
    fill: "url(#paint20_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.258 39.5614C107.258 40.7856 108.177 41.7038 109.402 41.7038C110.628 41.7038 111.547 40.7856 111.547 39.5614C111.547 38.3372 110.628 37.4191 109.402 37.4191C108.177 37.4191 107.258 38.3372 107.258 39.5614Z",
    fill: "url(#paint21_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9341 78.43C76.9341 79.6542 77.853 80.5723 79.0782 80.5723C80.3035 80.5723 81.2224 79.6542 81.2224 78.43C81.2224 77.3078 80.3035 76.2876 79.0782 76.2876C77.853 76.2876 76.9341 77.2058 76.9341 78.43Z",
    fill: "url(#paint22_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7866 121.175C69.7866 122.399 70.7055 123.318 71.9308 123.318C73.156 123.318 74.0749 122.399 74.0749 121.175C74.0749 120.053 73.156 119.033 71.9308 119.033C70.7055 119.033 69.7866 119.951 69.7866 121.175Z",
    fill: "url(#paint23_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0181 143.619C47.0181 144.843 47.937 145.761 49.1622 145.761C50.3874 145.761 51.3064 144.843 51.3064 143.619C51.3064 142.395 50.3874 141.477 49.1622 141.477C47.937 141.477 47.0181 142.395 47.0181 143.619Z",
    fill: "url(#paint24_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.712 127.092C216.712 128.316 217.631 129.235 218.856 129.235C220.081 129.235 221 128.316 221 127.092C221 125.868 220.081 124.95 218.856 124.95C217.631 124.95 216.712 125.868 216.712 127.092Z",
    fill: "url(#paint25_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.799 127.398C157.799 128.52 158.718 129.541 159.943 129.541C161.168 129.541 162.087 128.622 162.087 127.398C162.087 126.174 161.168 125.256 159.943 125.256C158.718 125.256 157.799 126.174 157.799 127.398Z",
    fill: "url(#paint26_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5884 117.707C11.5884 118.931 12.5073 119.849 13.7325 119.849C14.9577 119.849 15.8767 118.931 15.8767 117.707C15.8767 116.482 14.9577 115.564 13.7325 115.564C12.5073 115.564 11.5884 116.482 11.5884 117.707Z",
    fill: "url(#paint27_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7329 107.097C81.7329 108.321 82.6518 109.239 83.8771 109.239C85.1023 109.239 86.0212 108.321 86.0212 107.097C86.0212 105.873 85.1023 104.954 83.8771 104.954C82.6518 104.954 81.7329 105.873 81.7329 107.097Z",
    fill: "url(#paint28_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9551 27.4213C77.9551 28.6455 78.874 29.5637 80.0992 29.5637C81.3244 29.5637 82.2434 28.6455 82.2434 27.4213C82.2434 26.2991 81.3244 25.2789 80.0992 25.2789C78.9761 25.2789 77.9551 26.1971 77.9551 27.4213Z",
    fill: "url(#paint29_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1924 4.36539C31.1924 5.48758 32.1113 6.50775 33.3365 6.50775C34.5618 6.50775 35.4807 5.58959 35.4807 4.36539C35.4807 3.14118 34.5618 2.22302 33.3365 2.22302C32.1113 2.22302 31.1924 3.14118 31.1924 4.36539Z",
    fill: "url(#paint30_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.867676 20.3821C0.867676 21.6063 1.7866 22.5245 3.01182 22.5245C4.23705 22.5245 5.15596 21.6063 5.15596 20.3821C5.15596 19.1579 4.23705 18.2397 3.01182 18.2397C1.7866 18.2397 0.867676 19.1579 0.867676 20.3821Z",
    fill: "url(#paint31_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9941 39.5614C40.9941 40.7856 41.9131 41.7038 43.1383 41.7038C44.3635 41.7038 45.2824 40.7856 45.2824 39.5614C45.2824 38.3372 44.3635 37.4191 43.1383 37.4191C41.9131 37.4191 40.9941 38.3372 40.9941 39.5614Z",
    fill: "url(#paint32_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.165 46.6006C190.165 47.7228 191.084 48.743 192.309 48.743C193.534 48.743 194.453 47.8248 194.453 46.6006C194.453 45.3764 193.534 44.4583 192.309 44.4583C191.084 44.4583 190.165 45.3764 190.165 46.6006Z",
    fill: "url(#paint33_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.273 60.781C166.273 62.5153 167.601 63.8415 169.234 63.8415C170.868 63.8415 172.195 62.5153 172.195 60.781C172.195 59.0467 170.868 57.8225 169.234 57.8225C167.601 57.8225 166.273 59.1487 166.273 60.781Z",
    fill: "url(#paint34_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0601 47.7228C83.0601 49.3551 84.3874 50.6813 86.021 50.6813C87.6547 50.6813 89.0841 49.3551 89.0841 47.7228C89.0841 46.0905 87.7568 44.7643 86.021 44.7643C84.2853 44.7643 83.0601 46.0905 83.0601 47.7228Z",
    fill: "url(#paint35_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6367 47.9268C23.6367 49.559 24.964 50.8853 26.5977 50.8853C28.2313 50.8853 29.5586 49.559 29.5586 47.9268C29.5586 46.2945 28.2313 44.9683 26.5977 44.9683C24.964 44.9683 23.6367 46.2945 23.6367 47.9268Z",
    fill: "url(#paint36_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.027 87.8156C198.027 89.4478 199.354 90.7741 200.988 90.7741C202.621 90.7741 203.949 89.4478 203.949 87.8156C203.949 86.1833 202.621 84.8571 200.988 84.8571C199.354 84.8571 198.027 86.1833 198.027 87.8156Z",
    fill: "url(#paint37_linear_11_214)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3301 36.1948H69.9908V35.4807H57.6364L47.1199 24.6669H23.8406L19.3481 20.2802H-0.868072L-12.7119 32.1142L-12.2014 32.7263L-0.459663 21.0963H19.0418L23.5343 25.483H46.8136L57.3301 36.1948Z",
    fill: "url(#paint38_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.895 52.4156L9.34222 52.3136L24.3512 37.419H39.5644L53.8587 51.5994H103.174L114.712 40.1735H131.048V39.3574H114.303L102.868 50.8853H54.165L39.9729 36.6029H24.0449L9.03592 51.5994H-11.895V52.4156Z",
    fill: "url(#paint39_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.234 62.7193H134.724L140.543 56.9043H164.742V56.0882H140.237L134.417 62.0052H101.642L81.5283 41.9078H50.7956L36.8076 27.9314H-0.35756L-6.58579 34.1544H-12.7119V34.9706H-6.17738L0.050848 28.7475H36.5013L50.4893 42.7239H81.222L101.234 62.7193Z",
    fill: "url(#paint40_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2939 109.851H44.8735L58.9636 95.875H76.7294L116.243 56.3943H130.741V55.5781H115.937L76.4231 95.0588H58.5552L44.5672 109.035H31.2939V109.851Z",
    fill: "url(#paint41_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4472 66.0859H34.3572L42.3211 58.0265H86.0208V56.4962H41.7085L33.6424 64.4536H15.0599L4.95175 54.3539H-12.7119V55.8841H4.33914L14.4472 66.0859Z",
    fill: "url(#paint42_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1621 80.6744H80.7117V79.8582H49.4684L39.6666 70.0646H5.56454L-0.867892 63.7395H-14.0391V64.5556H-1.1742L5.15613 70.8807H39.3603L49.1621 80.6744Z",
    fill: "url(#paint43_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8016 95.1608H40.6875L70.6034 65.2698H89.9007L104.297 79.6542H151.264L159.228 87.6115H170.561V85.9793H159.841L151.877 78.0219H104.91L90.6154 63.7395H69.9908L40.0749 93.6306H27.4142L20.9818 87.2035H-13.7329V88.7337H20.3692L26.8016 95.1608Z",
    fill: "url(#paint44_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7716 91.3861H96.4352L120.123 67.7181H147.486V66.1879H119.408L95.7205 89.8559H45.4863L34.4593 78.736H-12.7119V80.3683H33.7445L44.7716 91.3861Z",
    fill: "url(#paint45_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.102 96.8951H170.561V96.0789H153.408L141.768 84.449H108.279V85.2651H141.462L153.102 96.8951Z",
    fill: "url(#paint46_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.37861 129.031H58.6574L75.7085 112.096H106.339L118.285 100.058H130.537V99.2415H117.979L106.033 111.279H75.4022L58.3511 128.214H-1.0723L-11.793 117.503L-15.5708 117.605V118.319H-12.0993L-1.37861 129.031Z",
    fill: "url(#paint47_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62753 149.944H59.1681L64.3753 144.741H91.9428L127.781 108.933H176.075L183.324 116.176L183.835 115.564L176.483 108.117H127.474L91.5344 143.925H64.069L58.8618 149.23H8.93383L4.95185 145.251H-14.856V146.067H4.64554L8.62753 149.944Z",
    fill: "url(#paint48_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1922 116.789H140.646V115.972H99.4985L84.2853 100.772H29.8648L12.6096 83.5309H-14.0391V84.347H12.3033L29.5585 101.588H83.979L99.1922 116.789Z",
    fill: "url(#paint49_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.459 35.7867C68.459 36.6029 69.1737 37.419 69.9905 37.317C70.8073 37.317 71.6242 36.6029 71.522 35.7867C71.522 34.9706 70.8073 34.2565 69.9905 34.2565C69.1737 34.2565 68.459 34.9706 68.459 35.7867Z",
    fill: "url(#paint50_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.414 39.8674C129.414 40.6836 130.129 41.3977 130.946 41.3977C131.762 41.3977 132.477 40.6836 132.477 39.8674C132.477 39.0513 131.762 38.3372 130.946 38.3372C130.129 38.3372 129.414 39.0513 129.414 39.8674Z",
    fill: "url(#paint51_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.904 56.3943C128.904 57.2104 129.619 57.9245 130.435 57.9245C131.252 57.9245 131.967 57.2104 131.967 56.3943C131.967 55.5781 131.252 54.864 130.435 54.864C129.619 54.864 128.904 55.5781 128.904 56.3943Z",
    fill: "url(#paint52_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.724 96.4871C168.724 97.3032 169.438 98.0173 170.255 98.0173C171.072 98.0173 171.787 97.3032 171.787 96.4871C171.787 95.6709 171.072 94.9568 170.255 94.9568C169.438 94.9568 168.724 95.6709 168.724 96.4871Z",
    fill: "url(#paint53_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.646 84.857C106.646 85.7752 107.36 86.3873 108.177 86.4893C109.096 86.4893 109.709 85.7752 109.709 84.857C109.709 83.9389 108.994 83.3268 108.177 83.3268C107.36 83.3268 106.646 84.0409 106.646 84.857Z",
    fill: "url(#paint54_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.597 99.5476C128.597 100.466 129.312 101.078 130.129 101.078C130.946 101.078 131.66 100.364 131.66 99.5476C131.66 98.6294 130.946 98.0173 130.129 98.0173C129.312 98.0173 128.597 98.7315 128.597 99.5476Z",
    fill: "url(#paint55_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.738 108.933C125.738 109.851 126.453 110.463 127.27 110.463C128.087 110.463 128.801 109.749 128.801 108.933C128.801 108.117 128.087 107.403 127.168 107.403C126.249 107.403 125.636 108.117 125.636 108.933H125.738Z",
    fill: "url(#paint56_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6363 95.1608C57.6363 96.0789 58.351 96.691 59.1678 96.691C59.9846 96.691 60.6993 95.9769 60.6993 95.1608C60.6993 94.3446 59.9846 93.6305 59.1678 93.6305C58.2489 93.6305 57.5342 94.3446 57.5342 95.1608H57.6363Z",
    fill: "url(#paint57_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0327 70.0646C38.0327 70.9827 38.7474 71.5948 39.6663 71.5948C40.5853 71.5948 41.1979 70.8807 41.1979 70.0646C41.1979 69.2484 40.4832 68.5343 39.6663 68.5343C38.8495 68.5343 38.0327 69.2484 38.0327 70.0646Z",
    fill: "url(#paint58_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.438 51.2933C101.438 52.2115 102.153 52.8236 102.97 52.8236C103.786 52.8236 104.501 52.1095 104.603 51.2933C104.603 50.4772 103.888 49.7631 102.97 49.7631C102.051 49.7631 101.438 50.4772 101.438 51.2933Z",
    fill: "url(#paint59_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0776 80.0622C79.0776 80.8784 79.7924 81.5925 80.6092 81.5925C81.426 81.5925 82.1407 80.8784 82.1407 80.0622C82.1407 79.1441 81.426 78.532 80.6092 78.532C79.7924 78.532 79.0776 79.2461 79.0776 80.0622Z",
    fill: "url(#paint60_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7686 111.586C73.7686 112.402 74.4833 113.116 75.3001 113.116C76.1169 113.116 76.8316 112.402 76.8316 111.586C76.8316 110.769 76.1169 110.055 75.3001 110.055C74.4833 110.055 73.7686 110.769 73.7686 111.586Z",
    fill: "url(#paint61_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9219 128.214C56.9219 129.133 57.6366 129.847 58.4534 129.745C59.2702 129.745 60.087 129.031 60.087 128.214C60.087 127.398 59.3723 126.684 58.4534 126.684C57.5345 126.684 56.9219 127.398 56.9219 128.214Z",
    fill: "url(#paint62_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.405 115.972C182.405 116.788 183.12 117.503 183.937 117.503C184.754 117.503 185.468 116.788 185.468 115.972C185.468 115.054 184.754 114.442 183.937 114.442C183.12 114.442 182.405 115.156 182.405 115.972Z",
    fill: "url(#paint63_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.808 116.278C138.808 117.095 139.522 117.809 140.339 117.809C141.156 117.809 141.871 117.095 141.871 116.278C141.871 115.36 141.156 114.748 140.339 114.748C139.522 114.748 138.808 115.462 138.808 116.278Z",
    fill: "url(#paint64_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7837 109.035C30.7837 109.953 31.4984 110.565 32.3152 110.565C33.132 110.565 33.8468 109.851 33.8468 109.035C33.8468 108.219 33.132 107.505 32.3152 107.505C31.4984 107.505 30.7837 108.219 30.7837 109.035Z",
    fill: "url(#paint65_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.70605 64.0455C-2.70605 64.8617 -1.99134 65.5758 -1.17452 65.5758C-0.255603 65.5758 0.357011 64.8617 0.357011 64.0455C0.357011 63.2294 -0.357705 62.5153 -1.17452 62.5153C-1.99134 62.5153 -2.70605 63.2294 -2.70605 64.0455Z",
    fill: "url(#paint66_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5493 101.18C82.5493 101.996 83.264 102.71 84.0808 102.71C84.8977 102.71 85.7145 101.996 85.7145 101.078C85.7145 100.16 84.9998 99.5476 84.1829 99.5476C83.3661 99.5476 82.6514 100.262 82.6514 101.078L82.5493 101.18Z",
    fill: "url(#paint67_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7925 42.3159C79.7925 43.132 80.5072 43.8462 81.3241 43.8462C82.1409 43.8462 82.8556 43.132 82.8556 42.3159C82.8556 41.4998 82.1409 40.7856 81.3241 40.7856C80.5072 40.7856 79.6904 41.4998 79.6904 42.3159H79.7925Z",
    fill: "url(#paint68_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1802 25.2789C45.1802 26.0951 45.8949 26.8092 46.7117 26.8092C47.5285 26.8092 48.2432 26.0951 48.2432 25.2789C48.2432 24.4628 47.5285 23.6466 46.7117 23.7487C45.8949 23.7487 45.1802 24.4628 45.1802 25.2789Z",
    fill: "url(#paint69_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6123 20.5862C17.6123 21.4023 18.327 22.1164 19.1438 22.1164C19.9607 22.1164 20.6754 21.4023 20.6754 20.5862C20.6754 19.77 19.9607 19.0559 19.1438 19.0559C18.327 19.0559 17.6123 19.77 17.6123 20.5862Z",
    fill: "url(#paint70_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.19531 20.5862C-2.19531 21.4023 -1.4806 22.1164 -0.663785 22.1164C0.153032 22.1164 0.867748 21.4023 0.867748 20.5862C0.867748 19.77 0.153032 19.0559 -0.663785 19.0559C-1.4806 19.0559 -2.19531 19.77 -2.19531 20.5862Z",
    fill: "url(#paint71_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.88911 28.0334C-1.88911 28.8496 -1.1744 29.5637 -0.357579 29.5637C0.459238 29.5637 1.17395 28.8496 1.17395 28.0334C1.17395 27.2173 0.459238 26.5032 -0.357579 26.5032C-1.1744 26.5032 -1.99121 27.2173 -1.99121 28.0334H-1.88911Z",
    fill: "url(#paint72_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8198 37.113C22.8198 37.9292 23.5345 38.6433 24.3514 38.6433C25.1682 38.6433 25.8829 37.9292 25.8829 37.113C25.8829 36.2969 25.1682 35.5828 24.3514 35.5828C23.5345 35.5828 22.8198 36.2969 22.8198 37.113Z",
    fill: "url(#paint73_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5312 51.2933C52.5312 52.2115 53.246 52.8236 54.0628 52.8236C54.8796 52.8236 55.5943 52.1095 55.5943 51.2933C55.5943 50.4772 54.8796 49.7631 54.0628 49.7631C53.246 49.7631 52.5312 50.4772 52.5312 51.2933Z",
    fill: "url(#paint74_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.802 56.4963C162.802 57.3124 163.516 58.1286 164.333 58.0265C165.15 58.0265 165.865 57.3124 165.865 56.3943C165.865 55.4761 165.15 54.864 164.333 54.864C163.414 54.864 162.802 55.5781 162.802 56.3943V56.4963Z",
    fill: "url(#paint75_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.138 66.902C145.138 68.1262 146.159 69.1464 147.384 69.1464C148.609 69.1464 149.63 68.1262 149.63 66.902C149.63 65.6778 148.609 64.6576 147.384 64.6576C146.159 64.6576 145.138 65.6778 145.138 66.902Z",
    fill: "url(#paint76_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5703 57.3124C83.5703 58.5366 84.5913 59.5568 85.8166 59.5568C87.0418 59.5568 88.0628 58.5366 88.0628 57.3124C88.0628 56.0882 87.0418 55.17 85.8166 55.068C84.5913 55.068 83.5703 56.0882 83.5703 57.3124Z",
    fill: "url(#paint77_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5645 57.4144C39.5645 58.6386 40.5855 59.6588 41.8107 59.6588C43.0359 59.6588 44.057 58.6386 44.057 57.4144C44.057 56.1902 43.0359 55.17 41.8107 55.17C40.5855 55.17 39.5645 56.1902 39.5645 57.4144Z",
    fill: "url(#paint78_linear_11_214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52 86.9994C168.52 88.2236 169.541 89.2438 170.766 89.2438C171.991 89.2438 173.012 88.2236 173.012 86.9994C173.012 85.7752 171.991 84.755 170.766 84.755C169.541 84.755 168.52 85.7752 168.52 86.9994Z",
    fill: "url(#paint79_linear_11_214)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8022 42.3158H71.9314V41.7037H61.1085L51.9193 32.3181H31.601L27.7211 28.4414H10.0575L-0.356934 38.7452L0.153579 39.2552L10.3638 29.1555H27.4148L31.2947 33.0322H51.613L60.8022 42.3158Z",
    fill: "url(#paint80_linear_11_214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.357422 56.4962H18.94L32.0091 43.336H45.3844L57.8409 55.7821H100.826L110.934 45.7844H125.126V45.0703H110.628L100.52 55.17H58.1472L45.6908 42.7239H31.8049L18.6337 55.7821H0.357422V56.4962Z",
    fill: "url(#paint81_linear_11_214)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1926 65.4737H128.394L133.499 60.3728H154.634V59.6587H133.193L128.088 64.8616H99.4989L81.9374 47.3146H55.0845L42.9344 35.1746H10.568L5.05448 40.5815H-0.356934V41.2956H5.36078L10.7722 35.7867H42.6281L54.8803 48.0287H81.6311L99.1926 65.4737Z",
    fill: "url(#paint82_linear_11_214)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1353 106.587H49.9792L62.2314 94.4466H77.7509L112.261 59.9647H124.922V59.2506H111.955L77.4446 93.7325H61.9251L49.6728 105.975H38.0332L38.1353 106.587Z",
    fill: "url(#paint83_linear_11_214)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4329 68.3301H40.7902L47.7332 61.393H85.8172L85.9193 60.0667H47.2226L40.1776 67.0039H23.9434L15.0605 58.1284H-0.356934V59.5567H14.55L23.4329 68.3301Z",
    fill: "url(#paint84_linear_11_214)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7568 81.1844H81.3243V80.4702H53.961L45.3844 71.9008H15.5706L10.0571 66.3918H-1.48047V67.106H9.75076L15.3664 72.6149H45.1802L53.7568 81.1844Z",
    fill: "url(#paint85_linear_11_214)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1535 93.8345H46.3036L72.4418 67.7181H89.2886L101.745 80.2662H142.79L149.835 87.2034H159.637V85.8772H150.346L143.403 78.838H102.358L89.7991 66.3918H71.8292L45.7931 92.4063H34.7661L29.1505 86.8973H-1.17383V88.2235H28.5379L34.1535 93.8345Z",
    fill: "url(#paint86_linear_11_214)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8773 90.5699H94.9043L115.631 69.8604H139.523L139.625 68.5342H115.018L94.3938 89.1417H50.4899L40.7902 79.552H-0.356934V80.8783H40.2797L49.8773 90.5699Z",
    fill: "url(#paint87_linear_11_214)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.423 95.3648H159.739L159.637 94.6507H144.73L134.52 84.449H105.318V85.1631H134.315L144.423 95.3648Z",
    fill: "url(#paint88_linear_11_214)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64884 123.42H62.0272L76.832 108.525H103.583L114.099 98.0173H124.718V97.4052H113.793L103.276 107.913H76.5257L61.7209 122.705H9.85305L0.459652 113.32H-2.80762V114.034H0.255448L9.64884 123.42Z",
    fill: "url(#paint89_linear_11_214)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3276 141.681H62.4358L67.0304 137.09H91.0243L122.37 105.873H164.538L170.868 112.096L171.379 111.586L164.844 105.158H122.063L90.718 136.478H66.724L62.2316 140.967H18.5319L15.1625 137.6H-2.09277V138.212H14.8562L18.3276 141.681Z",
    fill: "url(#paint90_linear_11_214)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3544 112.708H133.601V111.994H97.6607L84.3874 98.7314H36.9099L21.7988 83.6328H-1.48047V84.3469H21.4925L36.6036 99.4455H84.0811L97.3544 112.708Z",
    fill: "url(#paint91_linear_11_214)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5015 42.0097C70.5015 42.7238 71.1141 43.3359 71.8288 43.3359C72.5435 43.3359 73.1561 42.7238 73.1561 42.0097C73.1561 41.2956 72.5435 40.6835 71.8288 40.6835C71.1141 40.6835 70.5015 41.2956 70.5015 42.0097Z",
    fill: "url(#paint92_linear_11_214)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.799 45.5804C123.799 46.3965 124.411 46.9066 125.126 46.9066C125.841 46.9066 126.453 46.2945 126.453 45.5804C126.453 44.8663 125.841 44.2542 125.126 44.2542C124.411 44.2542 123.799 44.8663 123.799 45.5804Z",
    fill: "url(#paint93_linear_11_214)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.289 59.9648C123.289 60.6789 123.901 61.291 124.616 61.291C125.331 61.291 125.943 60.6789 125.943 59.9648C125.943 59.2507 125.331 58.5365 124.616 58.6386C123.901 58.6386 123.289 59.2507 123.289 59.9648Z",
    fill: "url(#paint94_linear_11_214)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.106 94.9567C158.106 95.6708 158.718 96.2829 159.433 96.2829C160.148 96.2829 160.76 95.6708 160.76 94.9567C160.76 94.1406 160.148 93.6305 159.331 93.6305C158.514 93.6305 158.003 94.2426 158.003 94.9567H158.106Z",
    fill: "url(#paint95_linear_11_214)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.889 84.857C103.889 85.6731 104.502 86.2852 105.216 86.1832C105.931 86.1832 106.544 85.5711 106.544 84.857C106.544 84.1429 105.931 83.5308 105.216 83.5308C104.502 83.5308 103.889 84.1429 103.889 84.857Z",
    fill: "url(#paint96_linear_11_214)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M123.084 97.6092C123.084 98.4253 123.697 98.9354 124.412 98.9354C125.127 98.9354 125.739 98.3233 125.739 97.6092C125.739 96.8951 125.127 96.283 124.412 96.283C123.697 96.283 123.084 96.8951 123.084 97.6092Z",
    fill: "url(#paint97_linear_11_214)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120.634 105.873C120.634 106.587 121.246 107.199 121.961 107.199C122.676 107.199 123.288 106.587 123.288 105.873C123.288 105.158 122.676 104.546 121.961 104.546C121.246 104.546 120.634 105.158 120.634 105.873Z",
    fill: "url(#paint98_linear_11_214)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1084 93.8345C61.1084 94.5486 61.7211 95.1607 62.4358 95.1607C63.1505 95.1607 63.7631 94.5486 63.7631 93.8345C63.7631 93.0184 63.1505 92.5083 62.4358 92.4062C61.619 92.4062 61.0063 93.0184 61.0063 93.8345H61.1084Z",
    fill: "url(#paint99_linear_11_214)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9551 71.9008C43.9551 72.6149 44.5677 73.227 45.2824 73.227C45.9971 73.227 46.6097 72.6149 46.6097 71.9008C46.6097 71.1867 45.9971 70.5746 45.2824 70.5746C44.5677 70.5746 43.9551 71.1867 43.9551 71.9008Z",
    fill: "url(#paint100_linear_11_214)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2945 55.476C99.2945 56.2921 99.9071 56.8022 100.622 56.8022C101.337 56.8022 101.949 56.1901 101.949 55.476C101.949 54.7619 101.337 54.1498 100.622 54.1498C99.805 54.1498 99.1924 54.7619 99.1924 55.476H99.2945Z",
    fill: "url(#paint101_linear_11_214)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.793 80.5723C79.793 81.2864 80.4056 81.8985 81.1203 81.8985C81.835 81.8985 82.4476 81.2864 82.4476 80.5723C82.4476 79.8582 81.835 79.2461 81.1203 79.2461C80.4056 79.2461 79.793 79.8582 79.793 80.5723Z",
    fill: "url(#paint102_linear_11_214)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1986 108.117C75.1986 108.831 75.8112 109.443 76.526 109.443C77.2407 109.443 77.8533 108.831 77.8533 108.117C77.8533 107.403 77.2407 106.791 76.526 106.791C75.7091 106.791 75.0965 107.403 75.1986 108.117Z",
    fill: "url(#paint103_linear_11_214)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4956 122.705C60.4956 123.419 61.1082 124.032 61.8229 124.032C62.5376 124.032 63.1503 123.419 63.1503 122.705C63.1503 121.991 62.5376 121.379 61.8229 121.379C61.1082 121.379 60.4956 121.991 60.4956 122.705Z",
    fill: "url(#paint104_linear_11_214)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.051 111.994C170.051 112.708 170.664 113.32 171.379 113.32C172.093 113.32 172.706 112.708 172.706 111.994C172.706 111.279 172.093 110.667 171.379 110.667C170.664 110.667 170.051 111.279 170.051 111.994Z",
    fill: "url(#paint105_linear_11_214)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.967 112.198C131.967 112.912 132.58 113.524 133.295 113.524C134.009 113.524 134.622 112.912 134.622 112.198C134.622 111.484 134.009 110.871 133.295 110.871C132.58 110.871 131.967 111.484 131.967 112.198Z",
    fill: "url(#paint106_linear_11_214)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 105.975C37.625 106.689 38.2376 107.403 38.9523 107.301C39.667 107.301 40.2796 106.689 40.2796 105.975C40.2796 105.26 39.667 104.648 38.9523 104.648C38.2376 104.648 37.625 105.26 37.625 105.975Z",
    fill: "url(#paint107_linear_11_214)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42383 66.6979C8.42383 67.412 9.03644 68.0241 9.75115 68.0241C10.4659 68.0241 11.0785 67.412 11.0785 66.6979C11.0785 65.9838 10.4659 65.2697 9.75115 65.2697C9.03644 65.2697 8.42383 65.8818 8.42383 66.5959V66.6979Z",
    fill: "url(#paint108_linear_11_214)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.856 99.1395C82.856 99.8536 83.4686 100.466 84.1833 100.466C84.898 100.466 85.5107 99.8536 85.5107 99.1395C85.5107 98.4253 84.898 97.8132 84.0812 97.8132C83.2644 97.8132 82.7539 98.4253 82.7539 99.1395H82.856Z",
    fill: "url(#paint109_linear_11_214)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4058 47.6207C80.4058 48.4368 81.0184 48.9469 81.7331 48.9469C82.4478 48.9469 83.0604 48.3348 83.0604 47.6207C83.0604 46.9065 82.4478 46.2944 81.7331 46.2944C81.0184 46.2944 80.4058 46.9065 80.4058 47.6207Z",
    fill: "url(#paint110_linear_11_214)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2856 32.7261C50.2856 33.4403 50.8983 34.0524 51.613 34.0524C52.3277 34.0524 52.9403 33.4403 52.9403 32.7261C52.9403 32.012 52.3277 31.2979 51.613 31.3999C50.8983 31.3999 50.2856 32.012 50.2856 32.7261Z",
    fill: "url(#paint111_linear_11_214)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1895 28.7475C26.1895 29.4616 26.8021 30.0737 27.5168 30.0737C28.2315 30.0737 28.8441 29.4616 28.8441 28.7475C28.8441 28.0334 28.2315 27.4213 27.5168 27.4213C26.8021 27.4213 26.1895 28.0334 26.1895 28.7475Z",
    fill: "url(#paint112_linear_11_214)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 28.7475C8.83203 29.5636 9.44464 30.0737 10.1594 30.0737C10.8741 30.0737 11.4867 29.4616 11.4867 28.7475C11.4867 28.0334 10.8741 27.4213 10.1594 27.4213C9.44464 27.4213 8.83203 28.0334 8.83203 28.7475Z",
    fill: "url(#paint113_linear_11_214)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13818 35.2765C9.13818 35.9907 9.7508 36.6028 10.4655 36.6028C11.1802 36.6028 11.7928 35.9907 11.7928 35.2765C11.7928 34.5624 11.1802 33.9503 10.4655 33.9503C9.7508 33.9503 9.13818 34.5624 9.13818 35.2765Z",
    fill: "url(#paint114_linear_11_214)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6816 43.1319C30.6816 43.846 31.2943 44.4581 32.1111 44.4581C32.9279 44.4581 33.4384 43.846 33.4384 43.1319C33.4384 42.4178 32.8258 41.7037 32.1111 41.8057C31.3964 41.8057 30.7837 42.4178 30.7837 43.1319H30.6816Z",
    fill: "url(#paint115_linear_11_214)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6157 55.476C56.6157 56.2921 57.2283 56.8022 57.9431 56.8022C58.6578 56.8022 59.2704 56.1901 59.2704 55.476C59.2704 54.7619 58.6578 54.1498 57.9431 54.1498C57.2283 54.1498 56.6157 54.7619 56.6157 55.476Z",
    fill: "url(#paint116_linear_11_214)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.898 60.0668C152.898 60.7809 153.511 61.393 154.225 61.4951C154.94 61.4951 155.553 60.883 155.553 60.0668C155.553 59.2507 154.94 58.7406 154.225 58.7406C153.511 58.7406 152.898 59.3527 152.898 60.0668Z",
    fill: "url(#paint117_linear_11_214)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M137.48 69.1463C137.48 70.1665 138.399 71.0847 139.42 71.0847C140.441 71.0847 141.36 70.2685 141.36 69.1463C141.36 68.0241 140.441 67.208 139.42 67.208C138.399 67.208 137.48 68.0241 137.48 69.1463Z",
    fill: "url(#paint118_linear_11_214)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7749 60.7809C83.7749 61.903 84.5917 62.7192 85.7148 62.7192C86.838 62.7192 87.6548 61.903 87.6548 60.7809C87.6548 59.6587 86.838 58.8425 85.7148 58.8425C84.6938 58.8425 83.7749 59.6587 83.7749 60.7809Z",
    fill: "url(#paint119_linear_11_214)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3848 60.8829C45.3848 61.9031 46.2016 62.8212 47.3247 62.8212C48.4478 62.8212 49.2646 62.0051 49.2646 60.8829C49.2646 59.7607 48.4478 58.9446 47.3247 58.9446C46.2016 58.9446 45.3848 59.8627 45.3848 60.8829Z",
    fill: "url(#paint120_linear_11_214)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M158.003 86.5913C158.003 87.7135 158.922 88.5296 159.943 88.5296C160.964 88.5296 161.883 87.7135 161.883 86.5913C161.883 85.4691 160.964 84.653 159.943 84.653C158.922 84.653 158.003 85.5711 158.003 86.5913Z",
    fill: "url(#paint121_linear_11_214)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85272 31.808C8.11698 31.808 6.58545 30.3798 6.58545 28.5435C6.58545 26.8092 8.01488 25.2789 9.85272 25.2789C11.5885 25.2789 13.12 26.7072 13.12 28.5435C13.12 30.3798 11.6906 31.808 9.85272 31.808ZM9.85272 25.891C8.32119 25.891 7.19806 27.1152 7.19806 28.5435C7.19806 29.9717 8.42329 31.1959 9.85272 31.1959C11.2821 31.1959 12.5074 29.9717 12.5074 28.5435C12.5074 27.1152 11.2821 25.891 9.85272 25.891Z",
    fill: "url(#paint122_linear_11_214)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4142 31.7061C25.6785 31.7061 24.147 30.2779 24.147 28.4416C24.147 26.6052 25.5764 25.177 27.4142 25.177C29.2521 25.177 30.6815 26.6052 30.6815 28.4416C30.6815 30.2779 29.2521 31.7061 27.4142 31.7061ZM27.4142 25.7891C25.8827 25.7891 24.7596 27.0133 24.7596 28.4416C24.7596 29.8698 25.9848 31.094 27.4142 31.094C28.8437 31.094 30.0689 29.8698 30.0689 28.4416C30.0689 27.0133 28.8437 25.7891 27.4142 25.7891Z",
    fill: "url(#paint123_linear_11_214)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4084 35.7868C49.6726 35.7868 48.1411 34.3586 48.1411 32.5222C48.1411 30.6859 49.5705 29.2577 51.4084 29.2577C53.2462 29.2577 54.6757 30.6859 54.6757 32.5222C54.6757 34.3586 53.2462 35.7868 51.4084 35.7868ZM51.4084 29.8698C49.8768 29.8698 48.7537 31.094 48.7537 32.5222C48.7537 33.9505 49.9789 35.1747 51.4084 35.1747C52.8378 35.1747 54.063 33.9505 54.063 32.5222C54.063 31.094 52.8378 29.8698 51.4084 29.8698Z",
    fill: "url(#paint124_linear_11_214)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8288 44.9683C70.0931 44.9683 68.5615 43.5401 68.5615 41.7038C68.5615 39.8675 69.9909 38.4392 71.8288 38.4392C73.6666 38.4392 75.0961 39.8675 75.0961 41.7038C75.0961 43.5401 73.6666 44.9683 71.8288 44.9683ZM71.8288 39.0513C70.3994 39.0513 69.1741 40.2755 69.1741 41.7038C69.1741 43.132 70.3994 44.3562 71.8288 44.3562C73.2582 44.3562 74.4834 43.132 74.4834 41.7038C74.4834 40.2755 73.2582 39.0513 71.8288 39.0513Z",
    fill: "url(#paint125_linear_11_214)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.111 46.3965C30.3753 46.3965 28.8438 44.9683 28.8438 43.132C28.8438 41.2957 30.2732 39.8674 32.111 39.8674C33.9489 39.8674 35.3783 41.2957 35.3783 43.132C35.3783 44.9683 33.9489 46.3965 32.111 46.3965ZM32.111 40.4795C30.6816 40.4795 29.4564 41.7037 29.4564 43.132C29.4564 44.5602 30.6816 45.7844 32.111 45.7844C33.5404 45.7844 34.7657 44.5602 34.7657 43.132C34.7657 41.7037 33.5404 40.4795 32.111 40.4795Z",
    fill: "url(#paint126_linear_11_214)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M125.126 48.5389C123.39 48.5389 121.859 47.1106 121.859 45.2743C121.859 43.438 123.288 42.0098 125.126 42.0098C126.964 42.0098 128.393 43.438 128.393 45.2743C128.393 47.1106 126.964 48.5389 125.126 48.5389ZM125.126 42.6219C123.697 42.6219 122.471 43.8461 122.471 45.2743C122.471 46.7026 123.697 47.9268 125.126 47.9268C126.556 47.9268 127.781 46.7026 127.781 45.2743C127.781 43.8461 126.556 42.6219 125.126 42.6219Z",
    fill: "url(#paint127_linear_11_214)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0539 109.035C37.216 109.035 35.7866 107.607 35.7866 105.771C35.7866 104.036 37.216 102.506 39.0539 102.506C40.8917 102.506 42.3212 103.934 42.3212 105.771C42.3212 107.505 40.8917 109.035 39.0539 109.035ZM39.0539 103.118C37.6245 103.118 36.3992 104.342 36.3992 105.771C36.3992 107.199 37.6245 108.423 39.0539 108.423C40.4833 108.423 41.7085 107.199 41.7085 105.771C41.7085 104.342 40.4833 103.118 39.0539 103.118Z",
    fill: "url(#paint128_linear_11_214)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62.027 126.072C60.1892 126.072 58.7598 124.644 58.7598 122.808C58.7598 121.073 60.1892 119.543 62.027 119.543C63.8649 119.543 65.2943 120.971 65.2943 122.808C65.2943 124.644 63.8649 126.072 62.027 126.072ZM62.027 120.155C60.5976 120.155 59.3724 121.379 59.3724 122.808C59.3724 124.236 60.5976 125.46 62.027 125.46C63.4565 125.46 64.6817 124.236 64.6817 122.808C64.6817 121.379 63.4565 120.155 62.027 120.155Z",
    fill: "url(#paint129_linear_11_214)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M124.718 100.976C122.982 100.976 121.451 99.5475 121.451 97.7112C121.451 95.8749 122.88 94.4467 124.718 94.4467C126.556 94.4467 127.985 95.8749 127.985 97.7112C127.985 99.5475 126.556 100.976 124.718 100.976ZM124.718 95.0588C123.289 95.0588 122.063 96.283 122.063 97.7112C122.063 99.1395 123.289 100.364 124.718 100.364C126.147 100.364 127.373 99.1395 127.373 97.7112C127.373 96.283 126.147 95.0588 124.718 95.0588Z",
    fill: "url(#paint130_linear_11_214)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M171.583 114.952C169.847 114.952 168.315 113.524 168.315 111.688C168.315 109.851 169.745 108.423 171.583 108.423C173.421 108.423 174.85 109.851 174.85 111.688C174.85 113.524 173.421 114.952 171.583 114.952ZM171.583 109.035C170.051 109.035 168.928 110.259 168.928 111.688C168.928 113.116 170.153 114.34 171.583 114.34C173.012 114.34 174.237 113.116 174.237 111.688C174.237 110.259 173.012 109.035 171.583 109.035Z",
    fill: "url(#paint131_linear_11_214)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M133.703 115.462C131.865 115.462 130.436 114.034 130.436 112.198C130.436 110.361 131.865 108.933 133.703 108.933C135.541 108.933 136.97 110.361 136.97 112.198C136.97 114.034 135.541 115.462 133.703 115.462ZM133.703 109.545C132.273 109.545 131.048 110.769 131.048 112.198C131.048 113.626 132.273 114.85 133.703 114.85C135.132 114.85 136.357 113.626 136.357 112.198C136.357 110.769 135.132 109.545 133.703 109.545Z",
    fill: "url(#paint132_linear_11_214)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M159.33 97.9153C157.799 97.9153 156.574 96.6911 156.574 95.1608C156.574 93.6306 157.799 92.4064 159.33 92.4064C160.862 92.4064 162.087 93.6306 162.087 95.1608C162.087 96.6911 160.862 97.9153 159.33 97.9153ZM159.33 92.9165C158.105 92.9165 157.084 93.9366 157.084 95.1608C157.084 96.3851 158.105 97.4052 159.33 97.4052C160.556 97.4052 161.577 96.3851 161.577 95.1608C161.577 93.9366 160.556 92.9165 159.33 92.9165Z",
    fill: "url(#paint133_linear_11_214)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.328 62.7193C152.796 62.7193 151.571 61.4951 151.571 59.9648C151.571 58.4345 152.796 57.2103 154.328 57.2103C155.859 57.2103 157.084 58.4345 157.084 59.9648C157.084 61.4951 155.859 62.7193 154.328 62.7193ZM154.328 57.7204C153.102 57.7204 152.081 58.7406 152.081 59.9648C152.081 61.189 153.102 62.2092 154.328 62.2092C155.553 62.2092 156.574 61.189 156.574 59.9648C156.574 58.7406 155.553 57.7204 154.328 57.7204Z",
    fill: "url(#paint134_linear_11_214)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M124.82 62.5153C123.288 62.5153 122.063 61.2911 122.063 59.7608C122.063 58.2306 123.288 57.0063 124.82 57.0063C126.351 57.0063 127.576 58.2306 127.576 59.7608C127.576 61.2911 126.351 62.5153 124.82 62.5153ZM124.82 57.5164C123.595 57.5164 122.573 58.5366 122.573 59.7608C122.573 60.985 123.595 62.0052 124.82 62.0052C126.045 62.0052 127.066 60.985 127.066 59.7608C127.066 58.5366 126.045 57.5164 124.82 57.5164Z",
    fill: "url(#paint135_linear_11_214)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0178 65.3718C44.5674 65.3718 42.6274 63.4334 42.6274 60.985C42.6274 58.5366 44.5674 56.5983 47.0178 56.5983C49.4683 56.5983 51.4082 58.5366 51.4082 60.985C51.4082 63.4334 49.4683 65.3718 47.1199 65.2697L47.0178 65.3718ZM47.0178 57.4144C45.0779 57.4144 43.4443 59.0467 43.4443 60.985C43.4443 62.9233 45.0779 64.5556 47.0178 64.5556C48.9578 64.5556 50.5914 62.9233 50.5914 60.985C50.5914 59.0467 48.9578 57.4144 47.0178 57.4144Z",
    fill: "url(#paint136_linear_11_214)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6126 65.3718C83.1621 65.3718 81.2222 63.4334 81.2222 60.985C81.2222 58.5366 83.1621 56.5983 85.6126 56.5983C88.063 56.5983 90.003 58.5366 90.003 60.985C90.003 63.4334 88.063 65.2697 85.7147 65.2697L85.6126 65.3718ZM85.6126 57.4144C83.6726 57.4144 82.039 59.0467 82.039 60.985C82.039 62.9233 83.6726 64.5556 85.6126 64.5556C87.5525 64.5556 89.1861 62.9233 89.1861 60.985C89.1861 59.0467 87.5525 57.4144 85.6126 57.4144Z",
    fill: "url(#paint137_linear_11_214)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.523 73.5331C137.174 73.5331 135.132 71.5948 135.132 69.1464C135.132 66.698 137.072 64.7596 139.523 64.7596C141.973 64.7596 143.913 66.698 143.913 69.1464C143.913 71.5948 141.973 73.5331 139.523 73.5331ZM139.523 65.5758C137.583 65.5758 135.949 67.2081 135.949 69.1464C135.949 71.0847 137.583 72.717 139.625 72.717C141.667 72.717 143.198 71.0847 143.198 69.1464C143.198 67.2081 141.565 65.5758 139.625 65.5758H139.523Z",
    fill: "url(#paint138_linear_11_214)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M159.841 91.1822C157.492 91.1822 155.45 89.2438 155.45 86.7954C155.45 84.347 157.39 82.4087 159.841 82.4087C162.291 82.4087 164.231 84.347 164.231 86.7954C164.231 89.2438 162.291 91.1822 159.841 91.1822ZM159.841 83.2248C157.901 83.2248 156.267 84.8571 156.267 86.7954C156.267 88.7338 157.901 90.366 159.841 90.366C161.883 90.366 163.414 88.7338 163.414 86.7954C163.414 84.8571 161.781 83.2248 159.841 83.2248Z",
    fill: "url(#paint139_linear_11_214)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_214",
    x1: -57.5345,
    y1: 8.44616,
    x2: 253.264,
    y2: 8.44616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_214",
    x1: -57.5346,
    y1: 30.3798,
    x2: 253.264,
    y2: 30.3798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_214",
    x1: -57.5345,
    y1: 31.6041,
    x2: 253.264,
    y2: 31.6041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_214",
    x1: -57.5347,
    y1: 82.1026,
    x2: 253.264,
    y2: 82.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11_214",
    x1: -57.5345,
    y1: 51.7015,
    x2: 253.264,
    y2: 51.7015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11_214",
    x1: -57.5346,
    y1: 67.9222,
    x2: 253.264,
    y2: 67.9222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11_214",
    x1: -57.5343,
    y1: 77.7159,
    x2: 253.265,
    y2: 77.7159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11_214",
    x1: -57.5345,
    y1: 76.7977,
    x2: 253.264,
    y2: 76.7977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_11_214",
    x1: -57.5347,
    y1: 92.9164,
    x2: 253.264,
    y2: 92.9164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_11_214",
    x1: -57.5345,
    y1: 124.644,
    x2: 253.264,
    y2: 124.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_11_214",
    x1: -57.5346,
    y1: 144.741,
    x2: 253.264,
    y2: 144.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_11_214",
    x1: -57.5346,
    y1: 105.669,
    x2: 253.264,
    y2: 105.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_11_214",
    x1: -57.5345,
    y1: 18.7499,
    x2: 253.264,
    y2: 18.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_11_214",
    x1: -57.6366,
    y1: 24.1568,
    x2: 253.264,
    y2: 24.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_11_214",
    x1: -57.5346,
    y1: 46.4986,
    x2: 253.264,
    y2: 46.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_11_214",
    x1: -57.5348,
    y1: 100.772,
    x2: 253.264,
    y2: 100.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_11_214",
    x1: -57.6367,
    y1: 84.9591,
    x2: 253.264,
    y2: 84.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_11_214",
    x1: -57.6366,
    y1: 104.852,
    x2: 253.264,
    y2: 104.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_11_214",
    x1: -57.6366,
    y1: 117.503,
    x2: 253.264,
    y2: 117.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_11_214",
    x1: -57.5345,
    y1: 98.9355,
    x2: 253.264,
    y2: 98.9355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_11_214",
    x1: -57.5344,
    y1: 65.0657,
    x2: 253.264,
    y2: 65.0657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_11_214",
    x1: -57.5345,
    y1: 39.5614,
    x2: 253.264,
    y2: 39.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_11_214",
    x1: -57.5344,
    y1: 78.43,
    x2: 253.264,
    y2: 78.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_11_214",
    x1: -57.5347,
    y1: 121.175,
    x2: 253.264,
    y2: 121.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_11_214",
    x1: -57.5345,
    y1: 143.721,
    x2: 253.264,
    y2: 143.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_11_214",
    x1: -57.5344,
    y1: 127.092,
    x2: 253.264,
    y2: 127.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_11_214",
    x1: -57.5346,
    y1: 127.5,
    x2: 253.264,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_11_214",
    x1: -57.5348,
    y1: 117.707,
    x2: 253.264,
    y2: 117.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_11_214",
    x1: -57.5344,
    y1: 107.199,
    x2: 253.264,
    y2: 107.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_11_214",
    x1: -57.5344,
    y1: 27.4213,
    x2: 253.264,
    y2: 27.4213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_11_214",
    x1: -57.5344,
    y1: 4.36539,
    x2: 253.265,
    y2: 4.36539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_11_214",
    x1: -57.5347,
    y1: 20.3821,
    x2: 253.264,
    y2: 20.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_11_214",
    x1: -57.5344,
    y1: 39.5614,
    x2: 253.264,
    y2: 39.5614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_11_214",
    x1: -57.6368,
    y1: 46.7026,
    x2: 253.264,
    y2: 46.7026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_11_214",
    x1: -57.5343,
    y1: 60.781,
    x2: 253.264,
    y2: 60.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_11_214",
    x1: -57.5346,
    y1: 47.8248,
    x2: 253.264,
    y2: 47.8248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_11_214",
    x1: -57.5344,
    y1: 47.9268,
    x2: 253.264,
    y2: 47.9268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_11_214",
    x1: -57.5347,
    y1: 87.8156,
    x2: 253.264,
    y2: 87.8156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_11_214",
    x1: -57.5347,
    y1: 28.2375,
    x2: 253.264,
    y2: 28.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_11_214",
    x1: -57.5347,
    y1: 44.5603,
    x2: 253.264,
    y2: 44.5603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_11_214",
    x1: -57.5347,
    y1: 45.3764,
    x2: 253.264,
    y2: 45.3764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_11_214",
    x1: -57.5349,
    y1: 82.7147,
    x2: 253.264,
    y2: 82.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_11_214",
    x1: -57.5347,
    y1: 60.2709,
    x2: 253.264,
    y2: 60.2709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_11_214",
    x1: -57.5346,
    y1: 72.2069,
    x2: 253.264,
    y2: 72.2069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_11_214",
    x1: -57.5347,
    y1: 79.4502,
    x2: 253.264,
    y2: 79.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_11_214",
    x1: -57.5347,
    y1: 78.838,
    x2: 253.264,
    y2: 78.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_11_214",
    x1: -57.535,
    y1: 90.672,
    x2: 253.264,
    y2: 90.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_11_214",
    x1: -57.5348,
    y1: 114.238,
    x2: 253.264,
    y2: 114.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_11_214",
    x1: -57.5346,
    y1: 129.133,
    x2: 253.264,
    y2: 129.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_11_214",
    x1: -57.5346,
    y1: 100.16,
    x2: 253.264,
    y2: 100.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_11_214",
    x1: -57.5351,
    y1: 35.8887,
    x2: 253.264,
    y2: 35.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_11_214",
    x1: -57.6365,
    y1: 39.8674,
    x2: 253.264,
    y2: 39.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_11_214",
    x1: -57.5342,
    y1: 56.3943,
    x2: 253.264,
    y2: 56.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_11_214",
    x1: -57.5341,
    y1: 96.5891,
    x2: 253.264,
    y2: 96.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_11_214",
    x1: -57.5348,
    y1: 84.857,
    x2: 253.264,
    y2: 84.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_11_214",
    x1: -57.6366,
    y1: 99.5476,
    x2: 253.264,
    y2: 99.5476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_11_214",
    x1: -57.5358,
    y1: 108.933,
    x2: 253.264,
    y2: 108.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_11_214",
    x1: -57.5347,
    y1: 95.2628,
    x2: 253.264,
    y2: 95.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_11_214",
    x1: -57.5347,
    y1: 70.1666,
    x2: 253.264,
    y2: 70.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_11_214",
    x1: -57.6368,
    y1: 51.2933,
    x2: 253.264,
    y2: 51.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_11_214",
    x1: -57.5351,
    y1: 80.0622,
    x2: 253.264,
    y2: 80.0622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_11_214",
    x1: -57.5348,
    y1: 111.688,
    x2: 253.264,
    y2: 111.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_11_214",
    x1: -57.5347,
    y1: 128.316,
    x2: 253.264,
    y2: 128.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_11_214",
    x1: -57.6362,
    y1: 115.972,
    x2: 253.264,
    y2: 115.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_11_214",
    x1: -57.6363,
    y1: 116.278,
    x2: 253.264,
    y2: 116.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_11_214",
    x1: -57.5347,
    y1: 109.035,
    x2: 253.264,
    y2: 109.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_11_214",
    x1: -57.5349,
    y1: 64.1475,
    x2: 253.264,
    y2: 64.1475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_11_214",
    x1: -57.535,
    y1: 101.282,
    x2: 253.264,
    y2: 101.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_11_214",
    x1: -57.5346,
    y1: 42.3159,
    x2: 253.264,
    y2: 42.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_11_214",
    x1: -57.4325,
    y1: 25.2789,
    x2: 252.958,
    y2: 25.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_11_214",
    x1: -57.5349,
    y1: 20.6882,
    x2: 253.264,
    y2: 20.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_11_214",
    x1: -57.5346,
    y1: 20.6882,
    x2: 253.264,
    y2: 20.6882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_11_214",
    x1: -57.5347,
    y1: 28.1354,
    x2: 253.264,
    y2: 28.1354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_11_214",
    x1: -57.5346,
    y1: 37.113,
    x2: 253.264,
    y2: 37.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_11_214",
    x1: -57.5345,
    y1: 51.2933,
    x2: 253.263,
    y2: 51.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_11_214",
    x1: -57.534,
    y1: 56.4963,
    x2: 253.264,
    y2: 56.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_11_214",
    x1: -57.5352,
    y1: 67.004,
    x2: 253.264,
    y2: 67.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_11_214",
    x1: -57.5347,
    y1: 57.4144,
    x2: 253.264,
    y2: 57.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_11_214",
    x1: -57.5348,
    y1: 57.5164,
    x2: 253.264,
    y2: 57.5164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_11_214",
    x1: -57.5348,
    y1: 86.9994,
    x2: 253.264,
    y2: 86.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_11_214",
    x1: -57.5341,
    y1: 35.3786,
    x2: 253.265,
    y2: 35.3786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_11_214",
    x1: -57.5345,
    y1: 49.661,
    x2: 253.264,
    y2: 49.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_11_214",
    x1: -57.5341,
    y1: 50.3751,
    x2: 253.265,
    y2: 50.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_11_214",
    x1: -57.5344,
    y1: 83.0206,
    x2: 253.264,
    y2: 83.0206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_11_214",
    x1: -57.5341,
    y1: 63.3313,
    x2: 253.265,
    y2: 63.3313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_11_214",
    x1: -57.5345,
    y1: 73.8391,
    x2: 253.264,
    y2: 73.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_11_214",
    x1: -57.5342,
    y1: 80.1642,
    x2: 253.265,
    y2: 80.1642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_11_214",
    x1: -57.5341,
    y1: 79.552,
    x2: 253.265,
    y2: 79.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_11_214",
    x1: -57.5345,
    y1: 89.9579,
    x2: 253.264,
    y2: 89.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_11_214",
    x1: -57.5343,
    y1: 110.463,
    x2: 253.264,
    y2: 110.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_11_214",
    x1: -57.5342,
    y1: 123.42,
    x2: 253.265,
    y2: 123.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_11_214",
    x1: -57.5345,
    y1: 98.2213,
    x2: 253.264,
    y2: 98.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_11_214",
    x1: -57.5347,
    y1: 42.0097,
    x2: 253.264,
    y2: 42.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_11_214",
    x1: -57.5333,
    y1: 45.5804,
    x2: 253.263,
    y2: 45.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_11_214",
    x1: -57.5344,
    y1: 59.9648,
    x2: 253.265,
    y2: 59.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_11_214",
    x1: -57.5345,
    y1: 95.0587,
    x2: 253.265,
    y2: 95.0587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_11_214",
    x1: -57.5344,
    y1: 84.857,
    x2: 253.265,
    y2: 84.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_11_214",
    x1: -57.5343,
    y1: 97.6092,
    x2: 253.265,
    y2: 97.6092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_11_214",
    x1: -57.5345,
    y1: 105.873,
    x2: 253.265,
    y2: 105.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_11_214",
    x1: -57.534,
    y1: 93.8345,
    x2: 253.264,
    y2: 93.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_11_214",
    x1: -57.4324,
    y1: 72.0028,
    x2: 252.856,
    y2: 72.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_11_214",
    x1: -57.5341,
    y1: 55.476,
    x2: 253.264,
    y2: 55.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_11_214",
    x1: -57.534,
    y1: 80.5723,
    x2: 253.264,
    y2: 80.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_11_214",
    x1: -57.5342,
    y1: 108.219,
    x2: 253.265,
    y2: 108.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_11_214",
    x1: -57.5345,
    y1: 122.807,
    x2: 253.265,
    y2: 122.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_11_214",
    x1: -57.5345,
    y1: 111.994,
    x2: 253.265,
    y2: 111.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_11_214",
    x1: -57.5344,
    y1: 112.3,
    x2: 253.265,
    y2: 112.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_11_214",
    x1: -57.5339,
    y1: 105.975,
    x2: 253.264,
    y2: 105.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_11_214",
    x1: -57.5341,
    y1: 66.6979,
    x2: 253.264,
    y2: 66.6979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_11_214",
    x1: -57.5341,
    y1: 99.1395,
    x2: 253.264,
    y2: 99.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_11_214",
    x1: -57.5343,
    y1: 47.7227,
    x2: 253.265,
    y2: 47.7227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_11_214",
    x1: -57.5343,
    y1: 32.8282,
    x2: 253.265,
    y2: 32.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_11_214",
    x1: -57.5343,
    y1: 28.7475,
    x2: 253.265,
    y2: 28.7475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_11_214",
    x1: -57.5343,
    y1: 28.7475,
    x2: 253.264,
    y2: 28.7475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_11_214",
    x1: -57.5345,
    y1: 35.2765,
    x2: 253.265,
    y2: 35.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_11_214",
    x1: -57.5347,
    y1: 43.1319,
    x2: 253.265,
    y2: 43.1319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_11_214",
    x1: -57.5345,
    y1: 55.476,
    x2: 253.265,
    y2: 55.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_11_214",
    x1: -57.5347,
    y1: 60.0668,
    x2: 253.264,
    y2: 60.0668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_11_214",
    x1: -57.5351,
    y1: 69.2484,
    x2: 253.265,
    y2: 69.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_11_214",
    x1: -57.5345,
    y1: 60.7809,
    x2: 253.264,
    y2: 60.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_11_214",
    x1: -57.4321,
    y1: 60.8829,
    x2: 252.958,
    y2: 60.8829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_11_214",
    x1: -57.5347,
    y1: 86.6933,
    x2: 253.265,
    y2: 86.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_11_214",
    x1: -57.5347,
    y1: 28.5435,
    x2: 253.264,
    y2: 28.5435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_11_214",
    x1: -57.5347,
    y1: 28.5436,
    x2: 253.264,
    y2: 28.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_11_214",
    x1: -57.5346,
    y1: 32.5222,
    x2: 253.264,
    y2: 32.5222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_11_214",
    x1: -57.5346,
    y1: 41.8058,
    x2: 253.264,
    y2: 41.8058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_11_214",
    x1: -57.5346,
    y1: 43.234,
    x2: 253.264,
    y2: 43.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_11_214",
    x1: -57.5343,
    y1: 45.2743,
    x2: 253.264,
    y2: 45.2743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_11_214",
    x1: -57.5348,
    y1: 105.873,
    x2: 253.264,
    y2: 105.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_11_214",
    x1: -57.5346,
    y1: 122.91,
    x2: 253.264,
    y2: 122.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_11_214",
    x1: -57.5347,
    y1: 97.7112,
    x2: 253.265,
    y2: 97.7112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_11_214",
    x1: -57.5349,
    y1: 111.79,
    x2: 253.265,
    y2: 111.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_11_214",
    x1: -57.5343,
    y1: 112.198,
    x2: 253.264,
    y2: 112.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_11_214",
    x1: -57.5348,
    y1: 95.1608,
    x2: 253.265,
    y2: 95.1608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_11_214",
    x1: -57.5339,
    y1: 59.9648,
    x2: 253.264,
    y2: 59.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_11_214",
    x1: -57.5343,
    y1: 59.7608,
    x2: 253.264,
    y2: 59.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_11_214",
    x1: -57.5347,
    y1: 61.087,
    x2: 253.162,
    y2: 61.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_11_214",
    x1: -57.5347,
    y1: 61.087,
    x2: 253.264,
    y2: 61.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_11_214",
    x1: -57.5345,
    y1: 69.2484,
    x2: 253.265,
    y2: 69.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_11_214",
    x1: -57.535,
    y1: 86.8974,
    x2: 253.264,
    y2: 86.8974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 177,
    fill: "white",
    transform: "translate(-51 -12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignLines90Deg);
export default __webpack_public_path__ + "static/media/design-lines-90-deg.6c9e7acb4e77f160239f5500a2fa6757.svg";
export { ForwardRef as ReactComponent };